import React, { useEffect, useState } from "react";

import { Table } from "../../../Component/Table/Table";
import { URLS } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import { Toast } from "../../../Component/Toast";
import useStoreKv from "../../redux/store/useStorekv";
import { View_icon } from "../../../assets/img";
import CustomScroll from "../../../Component/CustomScroll";

const ClientActivity = () => {


  const { kv, set } = useStoreKv();
  const clientActivity = kv.clientactivity || [];

  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState("");
  const [popup, setPopup] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  const [owners, setOwners] = useState(clientActivity);
  const [idd, setIdd] = useState(null);
  const [ReasonData, setReasonData] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const getList = async () => {
    try {
      if (!kv.clientactivity || kv.clientactivity.length === 0) {
        setLoading(true);
      }
      const res = await get(`${URLS.CLIENTACTIVITY}`);
//       console.log("Fetched data:", res);

      if (res?.status === "success" && res?.data) {
        setOwners(res?.data);
        set("clientactivity", res?.data);
      } else {
        setOwners([]);
        set("clientactivity", []);
      }
    } catch (err) {
      Toast("Failed to load");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  // const handleBlock = async () => {
  //   const payload = {
  //     block_reason: reason,
  //   };

  //   try {
  //     setLoader(true);

  //     const res = await post(`${URLS.CLIENT}/${idd}/block`, payload);

  //     console.log("Block/unblock success:", res);

  //     if (res?.status === "success") {
  //       setPopup(false);
  //       getList();
  //     } else {
  //       console.error("Failed to change block status:", res);
  //     }
  //   } catch (err) {
  //     console.error("Error during block/unblock:", err);
  //   } finally {
  //     setLoader(false);
  //   }
  // };


  const handleBlock = async (status) => {

    const payload = {
      block_reason: reason,
    };

    try {
      setLoader(true);

      const changeStatus = status === 'Blocked' ? 'block' : 'unblock';
      const res = await post(`${URLS.CLIENT}/${idd}/${changeStatus}`, payload);

//       console.log("Block/unblock success:", res);

      if (res?.status === "success") {

        setPopup(null);

        getList();
      } else {
        console.error("Failed to change block status:", res);
      }
    } catch (err) {
      console.error("Error during block/unblock:", err);
    } finally {
      setLoader(false);
    }
  };




  const columns = React.useMemo(
    () => [
      {
        id: "client_id",
        Header: () => (
          <div style={{ textAlign: "center" }}>
            Client <br /> ID
          </div>
        ),
        accessor: "client_id",
        Cell: ({ value }) => <p className="ac-text text-center">{value}</p>,
      },

      {
        id: "inactive",
        Header: () => <div className="text-center">In Active Days</div>,
        accessor: "inactive_days",
        Cell: ({ value }) => (
          <p className="ac-text text-center">
            {Math.trunc(value)}
          </p>
        ),
      },

      {
        id: "walletbalance",
        Header: () => <div className="text-center">Wallet Balance</div>,
        accessor: "wallet_balance",
        Cell: ({ value }) => <p className="ac-text text-center">{value}</p>,
      },
      {
        Header: "Reasons",
        accessor: "reason",
        Cell: ({ value }) => {
          return (
            <div className="d-flex ac-jc gap-1">
              <p
                style={{
                  maxWidth: "50px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {value}
              </p>

              <button
                onClick={() => {
                  setSelectedReason(value);
                  setReasonData(true);
                }}
                className="cust-btn"
              >
                <img src={View_icon} height={15} alt="" className="view-btn" />
              </button>
            </div>
          );
        },
      },

      {
        id: "status",
        Header: () => <div className="text-center">Status</div>,
        accessor: "status",
        Cell: ({ value, row }) => (
          <button
            onClick={() => {
              setIdd(row.original?.client_id);
              const data = value === 0 ? "block" : "unblock"
              setPopup(data);
            }}
            style={{
              position: 'relative',
              bottom: 0,
              top: 0,
              width: '100%',
              padding: '2px 10px'
            }}
            className={`${value === 0 ? "deactive-btn" : "active-btn"
              } border-0 fs-sm-10 fs-md-12 f2 fs-lg-14 fs-xl-13`
            }
          >
            {value === 0 ? "Block" : "Unblock"}
          </button >
        ),
      },
    ],
    []
  );


  return (
    <div className="dashRightView ">
      <CustomScroll>
        <div className="container_overalls">
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners}
            show={false}
          />
        </div>
      </CustomScroll>
      {popup === 'block' && (
        <div className="img-popup-design1">
          <div className="img-popup1">
            <button className="close-btn" onClick={() => setPopup(null)}>
              ×
            </button>

            <textarea
              className="input-box3 f2"
              name="reason"
              onChange={(e) => setReason(e.target.value)}
              placeholder="Type your reason here..."
              rows="4"
            />

            <div className="d-flex ac-jc px-1 py-1">
              <button
                disabled={!reason}
                onClick={() => handleBlock('Blocked')}
                className="add-button w-100 f2 w-45 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  <span style={{ top: -1.5, position: 'relative' }}>Block User</span>
                )}

              </button>
            </div>
          </div>
        </div>
      )}

      {popup === "unblock" && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-16 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure, you want to Unblock ?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => setPopup(null)} className="no-btn f4 w-45">
                Close
              </button>
              <button
                onClick={handleBlock}
                className="yes-btn f2 w-45 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  <span style={{ top: -1.5, position: 'relative' }}>Confirm</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* VIEW REASON POPUP */}
      {ReasonData && (
        <div onClick={() => setReasonData(false)} className="img-popup-design3">
          <div className="img-popup3">
            <button className="close-btn" onClick={() => setReasonData(false)}>
              ×
            </button>

            <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announement_title2">
              Message
            </h4>

            <div className="messageShow">
              <p className="f2 fs-xs-16">{selectedReason}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientActivity;
